import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Smartphone } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Step 5 · Success — shown after Stripe hosted onboarding returns the
 * user back to Nymia. Explicitly does NOT redirect to /profile: the
 * user gets a dedicated "we're on it" page and can choose Profile or
 * Wallet as next stop.
 */
const StepSuccess = () => {
  const { t } = useTranslation('onboarding');
  const navigate = useNavigate();
  const appReturnUrl = sessionStorage.getItem('nymia_app_return_url') || '';

  return (
    <div className="text-center" data-testid="wizard-step-success">
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-500/15">
        <CheckCircle2 className="h-8 w-8 text-emerald-300" />
      </div>
      <h2 className="text-2xl font-semibold text-foreground" data-testid="success-title">
        {t('success_step.title')}
      </h2>
      <div className="mx-auto mt-3 max-w-md space-y-2 text-sm text-muted-foreground">
        <p>{t('success_step.line1')}</p>
        <p>{t('success_step.line2')}</p>
        <p>{t('success_step.line3')}</p>
      </div>
      {appReturnUrl && (
        <Button
          asChild
          className="gold-gradient mt-8 w-full text-black sm:w-auto"
          data-testid="success-cta-back-to-app"
        >
          <a href={appReturnUrl}>
            <Smartphone className="mr-2 h-4 w-4" /> {t('success_step.cta_app')}
          </a>
        </Button>
      )}
      <div className={`flex flex-col items-center justify-center gap-3 sm:flex-row ${appReturnUrl ? 'mt-3' : 'mt-8'}`}>
        <Button
          onClick={() => navigate('/profile')}
          className={appReturnUrl ? '' : 'gold-gradient text-black'}
          variant={appReturnUrl ? 'outline' : 'default'}
          data-testid="success-cta-profile"
        >
          {t('success_step.cta_home')}
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate('/wallet')}
          data-testid="success-cta-wallet"
        >
          {t('success_step.cta_wallet')}
        </Button>
      </div>
    </div>
  );
};

export default StepSuccess;
